// AUTO-GENERATED FILE. DO NOT EDIT.
// Generated by scripts/generate-addresses.mjs
// Source: ../doppler/Deployments.json
// WARNING: This file is an internal build artifact and is NOT part of the public API.
// WARNING: Do NOT import from this file directly. It should not appear in IDE IntelliSense/suggestions.
// WARNING: If you need Doppler addresses, import from @addresses.ts instead (e.g. use ADDRESSES / getAddresses).

/** @internal */
export type GeneratedDopplerDeployments = Record<
  string,
  Record<string, string>
>;

/** @internal */
export const GENERATED_DOPPLER_DEPLOYMENTS = {
  '1': {
    Airlock: '0xDe3599a2eC440B296373a983C85C365DA55d9dFA',
    Bundler: '0xf45588E8e0B1df9dB9ae7E20eCE5726AE931357c',
    DopplerCreateXDeployer: '0x103004E50Bed65DFBa30dD9c264B6BdF5e529B83',
    DopplerDeployer: '0xb35469ee64A87Afd19B31615094fE3962d73e421',
    DopplerERC20V1: '0xDB7B520bb5C3a2C5d4871198081911359f93be87',
    DopplerERC20V1Factory: '0x89C261C05B5F9b6BcBA07C199b8DeE7cFaD45292',
    DopplerHookInitializer: '0xBDF938149ac6a781F94FAa0ed45E6A0e984c6544',
    DopplerHookMigrator: '0x1E40b0875DDa35f41E15cFB475403859B8c860c4',
    GovernanceFactory: '0x9F309D79BEe3E8b2f56FaCF74b7195Df176c8F61',
    LaunchpadGovernanceFactory: '0x2A8DA67F277442cFF7Dc2143e52Fdd0cBF5A8175',
    LockableUniswapV3Initializer: '0xA2E0435225D52a8B950122752978007D758056d7',
    NoOpGovernanceFactory: '0xddAE8B3eD08184682f7Bc32B74d943cEEfEab638',
    NoOpMigrator: '0x233A71A7bB928b1357A1Ebf454298320989Ca5B5',
    Quoter: '0xce6cd4E35447E05A39A50A4bCf61f2DcD93A8f0D',
    RehypeDopplerHookInitializer: '0x5F9eB5f6726Fe88D5e39867967F5b833d2fA3215',
    RehypeDopplerHookMigrator: '0x660740D7d6Fb2C8998Fa3ffF459cceB9Ac12C84B',
    StreamableFeesLockerV2: '0xcE3212e6536F33cD6fbFEE265224131353Ca3D47',
    TimelockFactory: '0x9fd40af2baAfAF03513f091444e821c0d5b06ea0',
    TopUpDistributor: '0x435312320C0330B1999746753551CdFbD83aD814',
    UniswapV2Locker: '0x06731e30df4B0209ED19C39Ba8eD253e17b0E495',
    UniswapV2MigratorSplit: '0xD7abA5f1d80a330a6fe9E96F7bA122710E0912d3',
    UniswapV4Initializer: '0x53b4c21a6Cb61D64F636ABBfa6E8E90E6558e8ad',
  },
  '143': {
    Airlock: '0x660eAaEdEBc968f8f3694354FA8EC0b4c5Ba8D12',
    Bundler: '0xf45588E8e0B1df9dB9ae7E20eCE5726AE931357c',
    DopplerCreateXDeployer: '0x103004E50Bed65DFBa30dD9c264B6BdF5e529B83',
    DopplerDeployer: '0xb35469ee64A87Afd19B31615094fE3962d73e421',
    DopplerERC20V1: '0xDB7B520bb5C3a2C5d4871198081911359f93be87',
    DopplerERC20V1Factory: '0x89C261C05B5F9b6BcBA07C199b8DeE7cFaD45292',
    DopplerHookInitializer: '0x56ea13Da5f39863D3B3d54826187306Af7ada544',
    DopplerHookMigrator: '0x1E40b0875DDa35f41E15cFB475403859B8c860c4',
    GovernanceFactory: '0xFAafdE6a5b658684cC5eb0C5c2c755B00A246F45',
    LaunchpadGovernanceFactory: '0x5FBe931dc4B923A7abe4c47aD68d5bF9Eda5B76D',
    LockableUniswapV3Initializer: '0x8b4C7DB9121FC885689C0A50D5a1429F15AEc2a0',
    NoOpGovernanceFactory: '0xb4deE32EB70A5E55f3D2d861F49Fb3D79f7a14d9',
    NoOpMigrator: '0x5F3bA43D44375286296Cb85F1EA2EBfa25dde731',
    Quoter: '0xce6cd4E35447E05A39A50A4bCf61f2DcD93A8f0D',
    RehypeDopplerHookInitializer: '0x5F9eB5f6726Fe88D5e39867967F5b833d2fA3215',
    RehypeDopplerHookMigrator: '0x660740D7d6Fb2C8998Fa3ffF459cceB9Ac12C84B',
    StreamableFeesLockerV2: '0xcE3212e6536F33cD6fbFEE265224131353Ca3D47',
    TimelockFactory: '0x44610355465c1F5914C8B8ea0E7c887CC67459b2',
    TopUpDistributor: '0x435312320C0330B1999746753551CdFbD83aD814',
    UniswapV2Locker: '0x06731e30df4B0209ED19C39Ba8eD253e17b0E495',
    UniswapV2MigratorSplit: '0xD7abA5f1d80a330a6fe9E96F7bA122710E0912d3',
    UniswapV4Initializer: '0x53b4c21a6Cb61D64F636ABBfa6E8E90E6558e8ad',
  },
  '4663': {
    Airlock: '0xeb7C034704eF8Dcd2D32324c1545f62fB4aD0862',
    Bundler: '0xf45588E8e0B1df9dB9ae7E20eCE5726AE931357c',
    DN404Factory: '0x37A9Fa204a4d3A429FDED7e3469ab076C854Bc9d',
    DopplerCreateXDeployer: '0x103004E50Bed65DFBa30dD9c264B6BdF5e529B83',
    DopplerDeployer: '0x4389AD34938B14F25cff7ED983c53f5a42A2573f',
    DopplerERC20V1: '0x3Be8B97Fd0e713B5aBE0649Fa830223B6B4BC599',
    DopplerERC20V1Factory: '0x1B37D3a72082029c44B35B604Ea473617580b69a',
    DopplerHookInitializer: '0x4e3468951D49f2EEa976eD0D6e75fFCb44a9a544',
    DopplerHookMigrator: '0x7BF319d8e969f7596B1Bc171Da9ce322f67Ae0c4',
    DopplerLensQuoter: '0xf4c22465532f64777FfcD7770831AEca38F35c04',
    GovernanceFactory: '0xDeb0447DAE3EB177c4dbA8bBCCCa25c8F273B7ef',
    LaunchpadGovernanceFactory: '0xdb036746D65DD52126b1915f1AdF555e6C5237Cf',
    LockableUniswapV3Initializer: '0xde8886A0019Ea060B8378Ee37b8A23b8117F29A3',
    NoOpGovernanceFactory: '0x85f37f74Ef2478A770318bc810177a9835911aD7',
    NoOpMigrator: '0xba2F330EDb16cD8056f5988d8CE19BbC63475A0e',
    Quoter: '0xce6cd4E35447E05A39A50A4bCf61f2DcD93A8f0D',
    RehypeDopplerHookInitializer: '0x5F9eB5f6726Fe88D5e39867967F5b833d2fA3215',
    RehypeDopplerHookMigrator: '0x660740D7d6Fb2C8998Fa3ffF459cceB9Ac12C84B',
    StreamableFeesLockerV2: '0x7B6147AC3F615bdb764e7EbD5f517dac1AD163B8',
    SwapRestrictorDopplerHook: '0xC16c826F75338A5Ea626f94f8992191B4ce5abA2',
    TimelockFactory: '0x6076fdDFCaC0dD980e0350dfF5239feC3f86C578',
    TopUpDistributor: '0x46adee7595d48b1Ec53090e9bc78e1E69Fa0eF06',
    UniswapV2Locker: '0x63f6Efe03F25A8C6650b38d05C5a454051d642a5',
    UniswapV2MigratorSplit: '0xB05046cEa797c993FB5b583098B1c4682e9Da333',
    UniswapV4Initializer: '0x6cce158B6D1747617fc218592B4D60B239B957ea',
  },
  '8453': {
    Airlock: '0x660eAaEdEBc968f8f3694354FA8EC0b4c5Ba8D12',
    Bundler: '0xf45588E8e0B1df9dB9ae7E20eCE5726AE931357c',
    DN404Factory: '0x37A9Fa204a4d3A429FDED7e3469ab076C854Bc9d',
    DopplerCreateXDeployer: '0x103004E50Bed65DFBa30dD9c264B6BdF5e529B83',
    DopplerDeployer: '0xb35469ee64A87Afd19B31615094fE3962d73e421',
    DopplerERC20V1: '0xDB7B520bb5C3a2C5d4871198081911359f93be87',
    DopplerERC20V1Factory: '0x89C261C05B5F9b6BcBA07C199b8DeE7cFaD45292',
    DopplerHookInitializer: '0xBDF938149ac6a781F94FAa0ed45E6A0e984c6544',
    DopplerHookMigrator: '0x1E40b0875DDa35f41E15cFB475403859B8c860c4',
    DopplerLensQuoter: '0x43d0D97EC9241A8F05A264f94B82A1d2E600f2B3',
    GovernanceFactory: '0xa82c66b6ddEb92089015C3565E05B5c9750b2d4B',
    LaunchpadGovernanceFactory: '0x40Bcb4dDA3BcF7dba30C5d10c31EE2791ed9ddCa',
    LockableUniswapV3Initializer: '0xE0dC4012AC9C868F09c6e4b20d66ED46D6F258d0',
    NoOpGovernanceFactory: '0xe7dfbd5b0A2C3B4464653A9beCdc489229eF090E',
    NoOpMigrator: '0x6ddfED58D238Ca3195E49d8ac3d4cEa6386E5C33',
    Quoter: '0xce6cd4E35447E05A39A50A4bCf61f2DcD93A8f0D',
    RehypeDopplerHookInitializer: '0x5F9eB5f6726Fe88D5e39867967F5b833d2fA3215',
    RehypeDopplerHookMigrator: '0x660740D7d6Fb2C8998Fa3ffF459cceB9Ac12C84B',
    StreamableFeesLockerV2: '0xcE3212e6536F33cD6fbFEE265224131353Ca3D47',
    TimelockFactory: '0xa636bD5F9179E80e9EdB371Ed90956fA5ebdCB33',
    TopUpDistributor: '0x435312320C0330B1999746753551CdFbD83aD814',
    UniswapV2Locker: '0x06731e30df4B0209ED19C39Ba8eD253e17b0E495',
    UniswapV2MigratorSplit: '0xD7abA5f1d80a330a6fe9E96F7bA122710E0912d3',
    UniswapV4Initializer: '0x53b4c21a6Cb61D64F636ABBfa6E8E90E6558e8ad',
  },
  '42161': {
    Airlock: '0xeb7C034704eF8Dcd2D32324c1545f62fB4aD0862',
    Bundler: '0xf45588E8e0B1df9dB9ae7E20eCE5726AE931357c',
    DN404Factory: '0x37A9Fa204a4d3A429FDED7e3469ab076C854Bc9d',
    DopplerCreateXDeployer: '0x103004E50Bed65DFBa30dD9c264B6BdF5e529B83',
    DopplerDeployer: '0x4389AD34938B14F25cff7ED983c53f5a42A2573f',
    DopplerERC20V1: '0x3Be8B97Fd0e713B5aBE0649Fa830223B6B4BC599',
    DopplerERC20V1Factory: '0x1B37D3a72082029c44B35B604Ea473617580b69a',
    DopplerHookInitializer: '0xAa7f809BB3752f715fA2e418230667C382A56544',
    DopplerHookMigrator: '0x7BF319d8e969f7596B1Bc171Da9ce322f67Ae0c4',
    DopplerLensQuoter: '0xf4c22465532f64777FfcD7770831AEca38F35c04',
    GovernanceFactory: '0xDeb0447DAE3EB177c4dbA8bBCCCa25c8F273B7ef',
    LaunchpadGovernanceFactory: '0xdb036746D65DD52126b1915f1AdF555e6C5237Cf',
    LockableUniswapV3Initializer: '0xde8886A0019Ea060B8378Ee37b8A23b8117F29A3',
    NoOpGovernanceFactory: '0x85f37f74Ef2478A770318bc810177a9835911aD7',
    NoOpMigrator: '0xba2F330EDb16cD8056f5988d8CE19BbC63475A0e',
    Quoter: '0xc9Be59b344Ec66547A4C697aa374e959D59b0567',
    RehypeDopplerHookInitializer: '0x5F9eB5f6726Fe88D5e39867967F5b833d2fA3215',
    RehypeDopplerHookMigrator: '0x660740D7d6Fb2C8998Fa3ffF459cceB9Ac12C84B',
    StreamableFeesLockerV2: '0xEd822828B6109d16a9D362b8146a35789E0064f5',
    SwapRestrictorDopplerHook: '0xC16c826F75338A5Ea626f94f8992191B4ce5abA2',
    TimelockFactory: '0x6076fdDFCaC0dD980e0350dfF5239feC3f86C578',
    TopUpDistributor: '0x46adee7595d48b1Ec53090e9bc78e1E69Fa0eF06',
    UniswapV2Locker: '0x63f6Efe03F25A8C6650b38d05C5a454051d642a5',
    UniswapV2MigratorSplit: '0xB05046cEa797c993FB5b583098B1c4682e9Da333',
    UniswapV4Initializer: '0x6cce158B6D1747617fc218592B4D60B239B957ea',
  },
  '84532': {
    Airlock: '0x3411306Ce66c9469BFF1535BA955503c4Bde1C6e',
    AirlockMultisigTestnet: '0x0abCf819FD57C9f0141628410fFC273405E44426',
    Bundler: '0xDdDDDd67579B73fDdFf301DB92Fd4A01afD4613a',
    DN404Factory: '0x98b0Aa2e0f134dbB3eb157b5646D387E6D55243a',
    DopplerCreateXDeployer: '0x0000000000f13Ab5b685F03A412A26719aB6bE60',
    DopplerDeployer: '0xb35469ee64A87Afd19B31615094fE3962d73e421',
    DopplerERC20V1: '0xDB7B520bb5C3a2C5d4871198081911359f93be87',
    DopplerERC20V1Factory: '0x89C261C05B5F9b6BcBA07C199b8DeE7cFaD45292',
    DopplerHookInitializer: '0xBDF938149ac6a781F94FAa0ed45E6A0e984c6544',
    DopplerHookMigrator: '0x1E40b0875DDa35f41E15cFB475403859B8c860c4',
    DopplerLensQuoter: '0x4a8d81Db741248a36D9eb3bc6eF648Bf798B47a7',
    GovernanceFactory: '0x9dBFaaDC8c0cB2c34bA698DD9426555336992e20',
    LaunchpadGovernanceFactory: '0x0902e7C7207df8ed6303Aef4382bcab181b5fBFA',
    LockableUniswapV3Initializer: '0x16AdA5Be50C3c2D94Af5fEae6b539C40A78Ad53c',
    NoOpGovernanceFactory: '0x7bD798fafC99A3b17E261F8308A8C11B56935ea1',
    NoOpMigrator: '0xF11066abbd329ac4bBA39455340539322C222eb0',
    Quoter: '0xc20347a97646ed6e2B45DBfEcE372f68d928ec0a',
    RehypeDopplerHookInitializer: '0xAdB90eF4dc001CFB81ecADEd2CDbda7D18487606',
    RehypeDopplerHookMigrator: '0x5E2A91F8eBE288e0AA76a0C1A47877Ded801e90d',
    StreamableFeesLockerV2: '0xcE3212e6536F33cD6fbFEE265224131353Ca3D47',
    TimelockFactory: '0x80F42ECCc91177D39E20f1A88A54D231c1b086a2',
    TopUpDistributor: '0x435312320C0330B1999746753551CdFbD83aD814',
    UniswapV2Locker: '0x06731e30df4B0209ED19C39Ba8eD253e17b0E495',
    UniswapV2MigratorSplit: '0xD7abA5f1d80a330a6fe9E96F7bA122710E0912d3',
    UniswapV4Initializer: '0x53b4c21a6Cb61D64F636ABBfa6E8E90E6558e8ad',
  },
} as const;
